import { render } from "./CardHeight.vue?vue&type=template&id=b55047aa"
import script from "./CardHeight.vue?vue&type=script&lang=js"
export * from "./CardHeight.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__